// extracted by css-extract-rspack-plugin
export default {"tabButton":"L3Seow","tab":"sVOeVi","wrapper":"q3lp4e","tag":"SAx3Jv","active":"Y1Rftr"};